import Cookies from 'js-cookie';

const TokenKey = 'Admin-Token';

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function isLogged() {
  return !!getToken();
}

export function setLogged(isLogged) {
  // Backwards compatibility, though effectively unused if we switch to setToken
  if (isLogged) {
    // If we are just setting connection status without a token, this might be problematic if we expect a token.
    // But existing code called setLogged('1').
    // We should probably discourage this or ensure we only use setToken with actual token.
    // For now, let's just leave it but prefer setToken.
    // If someone calls setLogged('1'), it sets the token to '1', which is an invalid token but makes isLogged() true.
    return Cookies.set(TokenKey, isLogged);
  }
}
